// import RewardCard from "../Cards/Reward";
import React from "react";
import "./1vs1.css";
import ChallengesCard from "../Cards/ChallengesCard";

export const ExistingGames = (props) => {
  return (
    <>
      <div className="row">
        <div className="row head-row mt-2">
          <div className="col-lg-12">
            <h1>Existing Challenges</h1>
          </div>
        </div>
      </div>
      <section className="challenges modal-challenges">
        {props.challenges.map((item, index) => (
          <div className="custom-bet-main">
            <ChallengesCard
              key={index}
              className="modal-contents"
              col={2}
              gameInfo={item}
            />
          </div>
        ))}
      </section>
    </>
  );
};
